import camelCase from 'camelcase';
import {
  SUBSCRIPTION_OFFERS_REQUEST,
  SUBSCRIPTION_OFFERS_SUCCESS,
  SUBSCRIPTION_OFFERS_FAILURE,
} from './types';

const initialState = {
  loading: false,
};

const camelCaseKeys = (object) => {
  const keys = Object.keys(object);
  const newObject = {};

  keys.forEach((key) => {
    newObject[camelCase(key)] = object[key];
  });

  return newObject;
};

export default function subscriptionsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SUBSCRIPTION_OFFERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SUBSCRIPTION_OFFERS_SUCCESS: {
      const { eligible, eligible_for_free_trial: eligibleForFreeTrial, offers } = action.payload;

      return {
        ...state,
        loading: false,
        eligible,
        eligibleForFreeTrial,
        offers: offers.map((offer) => camelCaseKeys(offer)),
      };
    }
    case SUBSCRIPTION_OFFERS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
